/**
 * Product Image Interface
 */
export interface ProductImage {
  productID: string;
  productName: string;
  productImageUrl: string;
  totalAvailableProduct: number;
  productStatus: string;
}

/**
 * Returns an array of product objects based on images in the assets/product images folder
 * @returns Array of ProductImage objects
 */
export function getProductImages(): ProductImage[] {
  const products: ProductImage[] = [
    // {
    //   productID: "AC100",
    //   productName: "AC100",
    //   productImageUrl: "assets/images/product images/AC100.png",
    //   totalAvailableProduct: 0,
    //   productStatus: "active",
    // },
    // {
    //   productID: "APK-IP40",
    //   productName: "Access Point K IP 40",
    //   productImageUrl: "assets/images/product images/Access Point K IP 40.jpg",
    //   totalAvailableProduct: 0,
    //   productStatus: "active",
    // },
    // {
    //   productID: "APK-IP68",
    //   productName: "Access Point K IP68",
    //   productImageUrl: "assets/images/product images/Access Point K IP68.jpg",
    //   totalAvailableProduct: 0,
    //   productStatus: "active",
    // },
    {
      productID: "AL100",
      productName: "AL100",
      productImageUrl: "assets/images/product images/AL100.jpg",
      totalAvailableProduct: 0,
      productStatus: "active",
    },
    // {
    //   productID: "AL200-ANSI",
    //   productName: "AL200 ANSI",
    //   productImageUrl: "assets/images/product images/AL200 ANSI.jpg",
    //   totalAvailableProduct: 0,
    //   productStatus: "active",
    // },
    {
      productID: "AL200-DIN",
      productName: "AL200 DIN",
      productImageUrl: "assets/images/product images/AL200 DIN.jpg",
      totalAvailableProduct: 0,
      productStatus: "active",
    },
    {
      productID: "AL200-Sis",
      productName: "AL200 SIS",
      productImageUrl: "assets/images/product images/AL200 SIS.jpg",
      totalAvailableProduct: 0,
      productStatus: "active",
    },
    {
      productID: "AL344-EU",
      productName: "AL344 EU",
      productImageUrl: "assets/images/product images/AL344.EU.png",
      totalAvailableProduct: 0,
      productStatus: "active",
    },
    {
      productID: "AL344-US",
      productName: "AL344 US",
      productImageUrl: "assets/images/product images/AL344.US.png",
      totalAvailableProduct: 0,
      productStatus: "active",
    },
    {
      productID: "AL344K-EU",
      productName: "AL344K EU",
      productImageUrl: "assets/images/product images/AL344K.EU.png",
      totalAvailableProduct: 0,
      productStatus: "active",
    },
    {
      productID: "AL344K-US",
      productName: "AL344K US",
      productImageUrl: "assets/images/product images/AL344K.US.png",
      totalAvailableProduct: 0,
      productStatus: "active",
    },
    // {
    //   productID: "AL344M",
    //   productName: "AL344M",
    //   productImageUrl: "assets/images/product images/AL344M.png",
    //   totalAvailableProduct: 0,
    //   productStatus: "active",
    // },
    // {
    //   productID: "AL344MK",
    //   productName: "AL344MK",
    //   productImageUrl: "assets/images/product images/AL344MK.png",
    //   totalAvailableProduct: 0,
    //   productStatus: "active",
    // },
    // {
    //   productID: "AL368-EU",
    //   productName: "AL368 EU",
    //   productImageUrl: "assets/images/product images/AL368.EU.png",
    //   totalAvailableProduct: 0,
    //   productStatus: "active",
    // },
    // {
    //   productID: "AL368-US",
    //   productName: "AL368 US",
    //   productImageUrl: "assets/images/product images/AL368.US.png",
    //   totalAvailableProduct: 0,
    //   productStatus: "active",
    // },
    // {
    //   productID: "AL368K-EU",
    //   productName: "AL368K EU",
    //   productImageUrl: "assets/images/product images/AL368K.EU.png",
    //   totalAvailableProduct: 0,
    //   productStatus: "active",
    // },
    // {
    //   productID: "AL368K-US",
    //   productName: "AL368K US",
    //   productImageUrl: "assets/images/product images/AL368K.US.png",
    //   totalAvailableProduct: 0,
    //   productStatus: "active",
    // },
    {
      productID: "AR100",
      productName: "AR100",
      productImageUrl: "assets/images/product images/AR100.jpg",
      totalAvailableProduct: 0,
      productStatus: "active",
    },
    {
      productID: "AR200",
      productName: "AR200",
      productImageUrl: "assets/images/product images/AR200.jpg",
      totalAvailableProduct: 0,
      productStatus: "active",
    },
    // {
    //   productID: "Encoder-K",
    //   productName: "Encoder K",
    //   productImageUrl: "assets/images/product images/Encoder K.jpg",
    //   totalAvailableProduct: 0,
    //   productStatus: "active",
    // },
    // {
    //   productID: "Energy-saver",
    //   productName: "Energy saver",
    //   productImageUrl: "assets/images/product images/Energy saver.jpg",
    //   totalAvailableProduct: 0,
    //   productStatus: "active",
    // },
    // {
    //   productID: "NFC-Handheld",
    //   productName: "NFC Handheld",
    //   productImageUrl: "assets/images/product images/NFC Handheld.jpg",
    //   totalAvailableProduct: 0,
    //   productStatus: "active",
    // },
    // {
    //   productID: "Silocker-K",
    //   productName: "Silocker K",
    //   productImageUrl: "assets/images/product images/Silocker K.jpg",
    //   totalAvailableProduct: 0,
    //   productStatus: "active",
    // },
    // {
    //   productID: "ST48-Elite",
    //   productName: "ST48 Elite",
    //   productImageUrl: "assets/images/product images/ST48 Elite.jpg",
    //   totalAvailableProduct: 0,
    //   productStatus: "active",
    // },
    {
      productID: "ST48-Ilock-XL",
      productName: "ST48 Ilock XL",
      productImageUrl: "assets/images/product images/ST48 Ilock XL.jpg",
      totalAvailableProduct: 0,
      productStatus: "active",
    },
    {
      productID: "ST48-Ilock-XS",
      productName: "ST48 Ilock XS",
      productImageUrl: "assets/images/product images/ST48 Ilock XS.jpg",
      totalAvailableProduct: 0,
      productStatus: "active",
    },
    {
      productID: "ST50-Elite",
      productName: "ST50 Elite",
      productImageUrl: "assets/images/product images/ST50 Elite.jpg",
      totalAvailableProduct: 0,
      productStatus: "active",
    },
    {
      productID: "ST50-Ilock-XL",
      productName: "ST50 Ilock XL",
      productImageUrl: "assets/images/product images/ST50 Ilock XL.jpg",
      totalAvailableProduct: 0,
      productStatus: "active",
    },
    {
      productID: "ST50-Ilock-XS",
      productName: "ST50 Ilock XS",
      productImageUrl: "assets/images/product images/ST50 Ilock XS.jpg",
      totalAvailableProduct: 0,
      productStatus: "active",
    },
    {
      productID: "ST50-Passport-IOL",
      productName: "ST50 Passport IOL",
      productImageUrl: "assets/images/product images/ST50 Passport IOL.jpg",
      totalAvailableProduct: 0,
      productStatus: "active",
    },
    {
      productID: "ST50-Passport-V2",
      productName: "ST50 Passport V2",
      productImageUrl: "assets/images/product images/ST50 Passport V2.jpg",
      totalAvailableProduct: 0,
      productStatus: "active",
    },
    // {
    //   productID: "WRH3",
    //   productName: "WRH3",
    //   productImageUrl: "assets/images/product images/WRH3.jpg",
    //   totalAvailableProduct: 0,
    //   productStatus: "active",
    // },
    // {
    //   productID: "WRK",
    //   productName: "WRK",
    //   productImageUrl: "assets/images/product images/WRK.jpg",
    //   totalAvailableProduct: 0,
    //   productStatus: "active",
    // },
  ];

  return products;
}

/**
 * Product images array constant
 */
export const PRODUCT_IMAGES: ProductImage[] = getProductImages();
